import type { AhVenue } from '../ahReport';
import { fmtNum, TIER_LABEL, gameLabel, visibleDetails, gamesCompleted } from '../utils';

function drawerMetrics(v: AhVenue): [string, number | string | null][] {
  if (v.tier === 'gold' || v.tier === 'silver') {
    const rows: [string, number | string | null][] = [
      ['Unique users (≈ opt-ins)', v.uniqueUsers ?? null],
      ['Unique players', v.uniquePlayers ?? null],
    ];
    if (v.tier === 'gold') rows.push(['Practice games', v.practiceStarts ?? null]);
    rows.push(['Total games played', v.gamesPlayed ?? null]);
    rows.push(['Games completed', gamesCompleted(v)]);
    rows.push(['Game completion rate', v.completionRate == null ? null : `${v.completionRate}%`]);
    rows.push(['Digital missions', v.digitalMissions ?? null]);
    if (v.tier === 'gold') rows.push(['Leaderboard entries', v.leaderboard ?? null]);
    rows.push(['Coupons distributed', v.vouchersGiven ?? null]);
    return rows;
  }
  const detailRows = visibleDetails(v);
  return v.tier === 'premium' ? [['Unique users', v.uniqueUsers ?? null], ...detailRows] : detailRows;
}

export function VenueDrawer({ venue, onClose }: { venue: AhVenue | null; onClose: () => void }) {
  return (
    <>
      <div className={'drawer-backdrop' + (venue ? ' visible' : '')} onClick={onClose} aria-hidden="true" />
      <aside className={'drawer' + (venue ? ' visible' : '')}>
        {venue && (
          <>
            <div className="drawer-head">
              <div>
                <div className="eyebrow" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ width: 10, height: 10, borderRadius: 2, background: venue.color, display: 'inline-block' }} />
                  {TIER_LABEL[venue.tier]} · {venue.period === 'both' ? 'Periode 1+2' : venue.period === 'w25' ? 'Alleen week 25' : `Periode ${venue.period}`}
                </div>
                <h2>{venue.name}</h2>
                {gameLabel(venue) && (
                  <div style={{ fontSize: 13, color: 'var(--ink-3)', marginTop: 6 }}>
                    Game: <strong style={{ color: 'var(--ink)' }}>{gameLabel(venue)}</strong>
                  </div>
                )}
              </div>
              <button className="drawer-close" onClick={onClose} aria-label="Sluiten">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
            <div className="drawer-body">
              <div className="ah-drawer-grid">
                <div>
                  <div className="ah-drawer-k">Bezoeken</div>
                  <div className="ah-drawer-v">{fmtNum(venue.visits)}</div>
                </div>
                <div>
                  <div className="ah-drawer-k">Gem. tijd / gebruiker</div>
                  <div className="ah-drawer-v">{venue.avgTime}</div>
                </div>
                <div>
                  <div className="ah-drawer-k">Totale tijd</div>
                  <div className="ah-drawer-v sm">{venue.totalTime}</div>
                </div>
                <div>
                  <div className="ah-drawer-k">Tier</div>
                  <div className="ah-drawer-v sm">{TIER_LABEL[venue.tier]}</div>
                </div>
              </div>
              <div style={{ marginTop: 24 }}>
                <h3 className="ah-drawer-subhead">Venue-specifieke metrics</h3>
                {drawerMetrics(venue).map(([k, val]) => (
                  <div key={k} className="stat-row">
                    <span className="label">{k}</span>
                    <span className="value">{val == null ? '—' : typeof val === 'number' ? fmtNum(val) : val}</span>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </aside>
    </>
  );
}
